import { NgModule, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ESignatureComponent } from './eSignature.component';
import { eSignatureRoutingModule } from './eSignature-routing.module';
import { MatExpansionModule} from '@angular/material/expansion';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ClipboardModule} from '@angular/cdk/clipboard';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule,MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CreateFillableFieldsComponent } from './create-fillable-fields/create-fillable-fields.component';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { EDashboardComponent } from './e-dashboard/e-dashboard.component';
import { ECanvasComponent } from './e-canvas/e-canvas.component';
import { MatTreeModule} from '@angular/material/tree';
import { SharedModule } from 'src/app/middleware/shared/shared.module';
import { StepOneComponent } from './step-one/step-one.component';
import { StepTwoComponent } from './step-two/step-two.component';
import { StepThreeComponent } from './step-three/step-three.component';
import { MatProgressBarModule} from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDividerModule } from '@angular/material/divider';
import { StepFourComponent } from './step-four/step-four.component';
import { HtmlCanvasComponent } from './html-canvas/html-canvas.component';
import { ShowReportComponent } from './show-report/show-report.component';
import { MatTableModule} from '@angular/material/table';
import { FormioModule } from 'angular-formio';
import { LeftMenuComponent } from './e-dashboard/left-menu/left-menu.component';
import { DocDetailComponent } from './e-dashboard/doc-detail/doc-detail.component';
import { GroupDetailComponent } from './e-dashboard/group-detail/group-detail.component';
import { InboxComponent } from './e-dashboard/inbox/inbox.component';
import { SentComponent } from './e-dashboard/sent/sent.component';
import { DraftComponent } from './e-dashboard/draft/draft.component';
import { MatChipsModule } from '@angular/material/chips';
import { FormFilterComponent } from './e-dashboard/form-filter/form-filter.component';
import { CdkTreeModule } from '@angular/cdk/tree';
import { ApiEndPointsForms } from './common/apiUrls/api-end-points-forms';
import { FormsService } from './services/forms.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AssociateContactRoleFormComponent } from './e-dashboard/associate-contact-role-form/associate-contact-role.component';
import { ApiEndPointsContact } from '../company/common/apiUrls/api-end-points-contact';
import { ContactsService } from '../company/services/contacts.service';
import { ApiEndPointsDocument } from '../company/common/apiUrls/api-end-points-document';
import { ContactsVm,ContactVm, FilteredContactVm } from 'src/app/viewModels/core/contacts-vm';
import { AssociateContactRoleFormListComponent } from './e-dashboard/associate-contact-role-list/associate-contact-role-list.component';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { DndModule } from 'ngx-drag-drop';
import { AngularDraggableModule } from 'angular2-draggable';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { AddFieldsVM } from 'src/app/viewModels/core/add-fields-vm';
import { AddSubFolderVM } from 'src/app/viewModels/core/add-sub-folder-vm';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { FavouriteComponent } from './e-dashboard/favourite/favourite.component';
import { DocumentPreviewComponent} from './document-preview/document-preview.component';
import { SignaturePadModule } from 'angular2-signaturepad';
import { ImageDrawingModule} from 'ngx-image-drawing';
import { MatButtonToggleModule} from '@angular/material/button-toggle';
import { AngularResizedEventModule } from 'angular-resize-event';
import { TrashComponent } from './e-dashboard/trash/trash.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from 'src/app/middleware/authentication/interceptor/auth-interceptor';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { StepOneTabularComponent } from './tabularForm/step-one-tabular/step-one-tabular.component';
import { StepTwoTabularComponent } from './tabularForm/step-two-tabular/step-two-tabular.component';
import { HTMLFormComponent } from './HTMLForm/HTMLForm.component';
import { HTMLDataComponent } from './e-dashboard/html-data/html-data.component';
import { CKEditorComponent, CKEditorModule } from 'ckeditor4-angular';
import { PDFFormReportComponent } from './e-dashboard/PDFFormReport/PDFFormReport.component';

@NgModule({
  declarations: [AssociateContactRoleFormComponent,AssociateContactRoleFormListComponent,ESignatureComponent, CreateFillableFieldsComponent, EDashboardComponent,
     ECanvasComponent, StepOneComponent, StepTwoComponent, StepThreeComponent,HTMLFormComponent,HTMLDataComponent,PDFFormReportComponent, StepFourComponent, 
     HtmlCanvasComponent, ShowReportComponent, LeftMenuComponent, DocDetailComponent, GroupDetailComponent,
     InboxComponent, SentComponent, DraftComponent,TrashComponent, FormFilterComponent, FavouriteComponent,DocumentPreviewComponent,
     StepOneTabularComponent,StepTwoTabularComponent],
     
  imports: [
    CKEditorModule,
    ClipboardModule,
    SignaturePadModule ,
    ImageDrawingModule,
    CommonModule,
    eSignatureRoutingModule,
    DragDropModule,
    MatExpansionModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule, 
    MatCheckboxModule,
    MatMenuModule,
    MatAutocompleteModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatRadioModule,
    MatTreeModule,
    SharedModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatTabsModule,
    MatDividerModule,
    MatTableModule,
    MatChipsModule,
    CdkTreeModule,
    MatDatepickerModule,
    MatTableModule,
    MatSlideToggleModule,
    FormioModule,
    DndModule,
    AngularDraggableModule,
    PdfViewerModule,
    NgxDocViewerModule,
    MatButtonToggleModule,
    NgxMaterialTimepickerModule,
    NgxDaterangepickerMd,
    AngularResizedEventModule,
    MatProgressSpinnerModule
  ],

  providers: [
    ApiEndPointsForms,
    ApiEndPointsContact,
    ContactsService,
    ApiEndPointsDocument,
    FilteredContactVm,
    ContactsVm,  
    ContactVm,
    AddSubFolderVM,
    AddFieldsVM,
    FormsService, 
    LoaderService,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true},      
  ],

    
})
export class ESignatureModule    { 

}